import { CRM_API, RequestHelper } from "utils";

const RUTA = "Reporte607";
export const Reporte607Service = (() => {
  const imprimirPDF = (params) =>
    RequestHelper(CRM_API).get(`${RUTA}/imprimir`, { ...params, FormatoReporte: "PDF" });

  const descargarExcel = (params) =>
    RequestHelper(CRM_API).get(`${RUTA}/imprimir`, { ...params, FormatoReporte: "EXCEL" }, true);

  const descargarCSV = (params) =>
    RequestHelper(CRM_API).get(`${RUTA}/imprimir`, { ...params, FormatoReporte: "CSV" }, true);

  return { imprimirPDF, descargarExcel, descargarCSV };
})();
